import React from 'react';
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';

import ResourcePortal from './ResourcePortal';
import { isTokenAlive, decodeAndReadToken } from 'lib/auth/tokenOperations';
import AuthService from 'lib/auth/AuthService';
import useGetTokenFromSearchQueryParams from 'v1/helpers/hooks/useGetTokenFromSearchQueryParams';

export const RESOURCE_PORTAL = 'atellioresourceportal';

const ResourcePortalRoute = () => {
  const cookies = new Cookies();
  let currentToken = '';

  // extract a token parameter from search query parameters
  const tokenFromQuery = useGetTokenFromSearchQueryParams('token');
  // a token query exists
  if (tokenFromQuery !== null) {
    // set the token as a cookie
    cookies.set(RESOURCE_PORTAL, tokenFromQuery);
    currentToken = tokenFromQuery;
  } else {
    // a token query does not exist, check if a cookie exists
    const tokenFromCookie = cookies.get(RESOURCE_PORTAL);

    if (tokenFromCookie !== null) {
      currentToken = tokenFromCookie;
    }
  }

  const renderPortal = currentToken => {
    if (!currentToken) {
      return <Redirect to="/unauthorized" />;
    }

    const { token, bearerToken } = decodeAndReadToken(currentToken);
    const isAlive = isTokenAlive(token);

    if (isAlive) {
      return <ResourcePortal token={token} bearerToken={bearerToken} />;
    } else {
      AuthService.logout();
      return <Redirect to="/login" />;
    }
  };

  return renderPortal(currentToken);
};

export default ResourcePortalRoute;
